import { routes as widget } from './widget'
import { routes as career } from './career'
import { routes as programguide } from './programguide'
import { routes as institution } from './institution'

export default [ ...widget, ...career, ...programguide, ...institution ]



// WEBPACK FOOTER //
// ./src/app/webWidgetRoutes.js